import React, { useEffect, useRef, useState } from 'react';
import p5 from 'p5';
import './LoadingSketch.css';

const LoadingSketch = ({ isLoading, onFadeComplete }) => {
    const sketchRef = useRef(null);
    const p5Instance = useRef(null);
    const opacity = useRef(1);
    const [isVisible, setIsVisible] = useState(true);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (!sketchRef.current) return;

        // p5.js sketch
        const sketch = (p) => {
            const gridX = 6;
            const gridY = 6;
            let canvas = null;

            p.setup = () => {
                if (!sketchRef.current) return;
                canvas = p.createCanvas(300, 300);
                canvas.parent(sketchRef.current);
                p.colorMode(p.HSB, 360, 100, 100);
                p.noStroke();
            };

            const drawSquare = (x, y, squareWidth, squareHeight, offsetY = 0) => {
                for (let i = 0; i < squareWidth; i++) {
                    let inter = p.map(i, 0, squareWidth, 0, 1);
                    let timeFactor = (p.sin(p.frameCount * 0.01 + x * 0.1 + y * 0.1) + 1) / .01;
                    let colorPos = (inter + timeFactor) % 1;
                    let interColor = p.lerpColor(p.color(0, 0, 0), p.color(255, 255, 255), colorPos);
                    p.stroke(interColor);
                    p.line(x * squareWidth + i, y * squareHeight + offsetY,
                        x * squareWidth + i, (y + 1) * squareHeight + offsetY);
                }
                p.noStroke();
            };

            p.draw = () => {
                if (!isMounted.current) return;

                // Update opacity based on loading state
                if (!isLoading && opacity.current > 0) {
                    opacity.current -= 0.02;
                    if (opacity.current <= 0) {
                        opacity.current = 0;
                        if (isMounted.current) {
                            setIsVisible(false);
                            onFadeComplete();
                        }
                    }
                }

                const bgColor = getComputedStyle(document.body).getPropertyValue('--main-bg-and-text-color').trim();
                p.background(bgColor);

                let squareWidth = p.width / gridX;
                let squareHeight = p.height / gridY;
                let offsetY = p.height / 2 - (squareHeight * gridY) / 2;

                for (let x = 0; x < gridX; x++) {
                    for (let y = 0; y < gridY; y++) {
                        drawSquare(x, y, squareWidth, squareHeight, offsetY);
                    }
                }
            };

            p.windowResized = () => {
                if (!isMounted.current) return;
                p.resizeCanvas(300, 300);
            };
        };

        // Create p5 instance
        if (!p5Instance.current) {
            p5Instance.current = new p5(sketch);
        }

        // Cleanup
        return () => {
            if (p5Instance.current) {
                try {
                    p5Instance.current.remove();
                } catch (error) {
                    console.error('Error cleaning up p5 instance:', error);
                }
                p5Instance.current = null;
            }
        };
    }, [isLoading, onFadeComplete]);

    if (!isVisible) return null;

    const containerStyle = {
        opacity: opacity.current
    };

    return (
        <div className="loading-sketch-container" style={containerStyle}>
            <h1 className="loading-title">Immuta.art</h1>
            <div className="canvas-wrapper">
                <img
                    src={`${process.env.PUBLIC_URL}/static/media/stone-art.png`}
                    alt=""
                    className="background-image"
                />
                <div id="canvas-container" ref={sketchRef} />
                <img
                    src={`${process.env.PUBLIC_URL}/static/media/i-trans.gif`}
                    alt=""
                    className="overlay-image"
                />
            </div>
        </div>
    );
};

export default LoadingSketch;